import Link from "next/link";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { AppRoutesEnum } from "@/constants/constants";

export const QuickLinks = () => {
  const { t } = useClientTranslations();
  return (
    <div className="mt-4 flex flex-col items-center justify-center gap-1 text-center text-xs font-normal text-stg-grey-4 md:fixed md:bottom-8 md:w-full">
      <div>{t("auth_screen.by_continuing_you_agree")}</div>
      <div className="flex w-full items-center justify-center font-semibold">
        <Link href="/terms" className="flex underline">
          {t("auth_screen.terms_of_use")}
        </Link>
        {" ,"}
        &nbsp;
        <Link href="/privacy" className="flex underline">
          {t("auth_screen.privacy_policy")}
        </Link>
        {" ,"}
        &nbsp;
        <Link href={AppRoutesEnum.REFUND_POLICY} className="flex underline">
          {t("auth_screen.refund_policy")}
        </Link>
      </div>
    </div>
  );
};
